<template>
  <div class="alipay-withhold-launch">
    <div class="launch-container">
      <div class="launch-header">
        <img class="logo-img" src="@assets/images/alipay.png" alt="支付宝" />
        <h1 class="title">{{ actionTitle }}</h1>
        <p class="subtitle">{{ headerTip }}</p>
      </div>

      <div class="launch-body">
        <div v-if="loading" class="loading-box">
          <div class="loading-spinner"></div>
          <p class="loading-text">正在准备跳转链接...</p>
        </div>

        <template v-else-if="isInWechat">
          <p class="desc">请点击右上角「...」，选择「在浏览器打开」以完成{{ actionTitle }}。</p>
          <div class="wechat-notice">
            <span class="notice-icon">!</span>
            <p>请在浏览器中打开当前页面后继续操作</p>
          </div>
          <button class="back-btn" @click="goBack">返回</button>
        </template>
      </div>
    </div>

    <browser-mask
      :visible.sync="showMask"
      :title="maskTitle"
      :message="maskMessage"
    />
  </div>
</template>

<script>
import BrowserMask from "@components/BrowserMask";
import { getDirectDebitLink } from "@api/order";
import { isWeixin } from "@utils";

export default {
  name: "AlipayWithholdLaunch",
  components: {
    BrowserMask
  },
  data() {
    return {
      isInWechat: false,
      loading: true,
      showMask: false
    };
  },
  computed: {
    linkType() {
      const type = parseInt(this.$route.query.type, 10);
      return type === 1 ? 1 : 0;
    },
    orderId() {
      return (this.$route.query.orderId || "").trim();
    },
    actionTitle() {
      return this.linkType === 1 ? "签署代扣协议" : "支付代扣服务费";
    },
    headerTip() {
      if (this.loading) {
        return "请稍候";
      }
      return this.isInWechat ? "请在浏览器中打开" : "即将前往支付宝";
    },
    maskTitle() {
      return this.linkType === 1 ? "签署提示" : "支付提示";
    },
    maskMessage() {
      const action = this.linkType === 1 ? "签署代扣协议" : "支付代扣服务费";
      return `请点击右上角<b>"..."</b>，选择<b>"在浏览器打开"</b>以完成${action}`;
    }
  },
  mounted() {
    this.isInWechat = isWeixin();
    this.initLaunch();
  },
  methods: {
    initLaunch() {
      if (!this.orderId) {
        this.loading = false;
        this.$dialog.error("订单号不存在", () => {
          this.$router.go(-1);
        });
        return;
      }

      if (this.isInWechat) {
        this.loading = false;
        this.showMask = true;
        return;
      }

      this.redirectToLink();
    },

    redirectToLink() {
      this.loading = true;
      getDirectDebitLink({
        orderId: this.orderId,
        type: this.linkType
      })
        .then(res => {
          const url = res.data && res.data.url;
          if (!url) {
            return Promise.reject({ msg: "未获取到跳转链接" });
          }
          window.location.replace(url);
        })
        .catch(err => {
          this.loading = false;
          this.$dialog.error(err.msg || "获取链接失败", () => {
            this.$router.go(-1);
          });
        });
    },

    goBack() {
      this.showMask = false;
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.alipay-withhold-launch {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 10vh 16px 24px;
  background: linear-gradient(180deg, #e8f3ff 0%, #f5f7fa 42%, #f5f7fa 100%);
}

.launch-container {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(22, 119, 255, 0.12);
}

.launch-header {
  padding: 32px 24px 28px;
  text-align: center;
  color: #fff;
  background: linear-gradient(135deg, #1677ff 0%, #0958d9 100%);
}

.logo-img {
  width: 56px;
  height: 56px;
  margin: 0 auto 16px;
  display: block;
  object-fit: contain;
}

.title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 600;
}

.subtitle {
  margin: 0;
  font-size: 14px;
  opacity: 0.92;
}

.launch-body {
  padding: 28px 24px 32px;
}

.loading-box {
  text-align: center;
}

.loading-spinner {
  width: 44px;
  height: 44px;
  margin: 0 auto 16px;
  border: 3px solid #e6f0ff;
  border-top-color: #1677ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.loading-text {
  margin: 0;
  font-size: 15px;
  color: #666;
}

.desc {
  margin: 0;
  font-size: 15px;
  line-height: 1.7;
  color: #333;
  text-align: center;
}

.wechat-notice {
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
  padding: 12px 14px;
  background: #fff8e6;
  border: 1px solid #ffe7a3;
  border-radius: 10px;
}

.notice-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-right: 10px;
  border-radius: 50%;
  background: #faad14;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.wechat-notice p {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: #8c6d1f;
}

.back-btn {
  display: block;
  width: 100%;
  margin-top: 36px;
  padding: 12px 0;
  border: 1px solid #d9d9d9;
  border-radius: 24px;
  background: #fff;
  color: #666;
  font-size: 16px;
  line-height: 1.4;
}

.back-btn:active {
  background: #f5f5f5;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
